module.exports = __webpack_public_path__ + "static/media/DVI.17d72f03.svg";